import axios from 'axios';
import apiUrl from './apiUrl';
import sitecode from '../sitecode';

const apiv4 = axios.create({
  baseURL: apiUrl(sitecode, 'v4'),
  withCredentials: true,
  // Per-environment XSRF cookie name matching the backend's SESSION_XSRF_COOKIE:
  // the prod XSRF-TOKEN cookie (Domain=.medic-clipboard.com) is also delivered to
  // dev hosts and would shadow the dev token (different APP_KEY → 419).
  xsrfCookieName: process.env.VUE_APP_XSRF_COOKIE || 'XSRF-TOKEN',
});

export default apiv4;
